/*  ========================================================================
    # Scripts - Accordion
    ========================================================================  */

/**
 * Script that handles the accordion section.
 */

const Accordion = {
  cfg: {
    accordions: document.querySelectorAll('.s-accordion'),
    classes: {
      entry: 's-accordion__entry',
      headline: 'headline',
      text: 'text',
      active: 'active'
    },
    transitionDuration: 400
  },

  /**
   * Set the corresponding height for every text container.
   *
   * @param {Object} text
   * @param {string} textHeight
   * @param {string} action
   */
  setHeight(text, textHeigh, action) {
    // Init
    if (action === 'init') {
      text.style.height = '0px';
      text.setAttribute('aria-hidden', 'true');
      text.setAttribute('inert', '');
    }

    // Show
    if (action === 'show') {
      text.style.height = textHeigh;
      text.setAttribute('aria-hidden', 'false');
      text.removeAttribute('inert');
      setTimeout(() => {
        text.style.height = 'auto';
      }, this.cfg.transitionDuration);
    }

    // Hide
    if (action === 'hide') {
      text.style.height = textHeigh;
      text.setAttribute('aria-hidden', 'true');
      text.setAttribute('inert', '');
      setTimeout(() => {
        text.style.height = '0px';
      }, 10);
    }
  },

  /**
   * Handler.
   *
   * @param {Object} accordion
   */
  handler(accordion) {
    accordion.entries.forEach(entry => {
      const text = entry.querySelector(`.${this.cfg.classes.text}`);
      let textHeigh = `${text.offsetHeight}px`;
      window.addEventListener('resize', () => {
        if (entry.classList.contains(this.cfg.classes.active)) {
          textHeigh = `${text.offsetHeight}px`;
        } else {
          text.style.height = 'auto';
          textHeigh = `${text.offsetHeight}px`;
          text.style.height = '0px';
        }
      });
      this.setHeight(text, textHeigh, 'init');

      entry.querySelector(`.${this.cfg.classes.headline}`).addEventListener('click', () => {
        if (entry.classList.contains(this.cfg.classes.active)) {
          entry.classList.remove(this.cfg.classes.active);
          entry.querySelector(`.${this.cfg.classes.headline}`).setAttribute('aria-expanded', 'false');
          this.setHeight(text, textHeigh, 'hide');
        } else {
          entry.classList.add(this.cfg.classes.active);
          entry.querySelector(`.${this.cfg.classes.headline}`).setAttribute('aria-expanded', 'true');
          this.setHeight(text, textHeigh, 'show');
        }
      });
    });
  },

  /**
   * Creates a accordion object for each accordion on the current page.
   */
  accordions() {
    this.cfg.accordions.forEach(accordion => {
      const accordionObject = {
        accordion,
        entries: accordion.querySelectorAll(`.${this.cfg.classes.entry}`)
      };

      this.handler(accordionObject);
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (typeof this.cfg.accordions !== undefined && this.cfg.accordions !== null) {
      this.accordions();
    }
  }
};

export default Accordion;
